import React, { useState, useEffect } from 'react';
import styles from '../style/MenuButton.module.scss';

type PrivateProps = {
  title: string;
  id: string
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  active?: boolean;
};

export default function MenuButton({
  title,
  onClick,
  id,
  active = false,
}: PrivateProps) {
  return (
    <button
      id={id}
      onClick={onClick}
      className={`${styles.menuButton} ${active ? styles.active : ''}`}
    >
      <div>{title}</div>
      <span className={styles.underline}></span>
    </button>
  );
}
